define('views/pages/OtherCountryPageView',['jquery', 'PageView','backbone', 'router','app','template!blocks/countries'], function ($, PageView ,Backbone, router, app, countriesTemplate) {

    return PageView.extend({
        pageName:'OtherCountry',
        displayAsModal: true,
        events: {
            'click .btn-close':'clickClose'
        },
        initialize: function(){
            var view = this;
            PageView.prototype.initialize.apply(view,arguments);
            view.menu = app.getMenu(app.c('_OTHER_COUNTRY_MENU_ID_'));
            view.contry = view.menu.getItems();

            this.render();
        },
        clickClose:function(){
            this.trigger('close',this);
        },
        render:function(){
            var view = this;
            var countries = [];
            view.contry.each(function(c)
            {
                    countries.push({link:c.get('link'), name:c.get('name')});
            });
           view.$el.html(countriesTemplate({
                countries:  countries,

            }));
            this.delegateEvents();

        }

    });

    return CountriesView;
});
